/**
 * API origin for cookie-based session calls. Prefer the page origin when it
 * differs from REACT_APP_BASE_URL (LAN IP vs localhost) so /api proxy + cookies match.
 */
export function resolveAppApiOrigin() {
  const configured = (process.env.REACT_APP_BASE_URL || '').trim().replace(/\/$/, '');
  if (typeof window === 'undefined') return configured;
  if (!configured) return '';
  if (configured !== window.location.origin) {
    return window.location.origin;
  }
  return configured;
}

export function appApiUrl(path) {
  const origin = resolveAppApiOrigin();
  const p = path.startsWith('/') ? path : `/${path}`;
  return origin ? `${origin}${p}` : p;
}
